/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_DisclaimersInputs */



/**
* | output |
* | --- |
* | "Disclaimers" |
*
* @param {Ad_Section_DisclaimersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_disclaimers = /** @type {((inputs?: Ad_Section_DisclaimersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_DisclaimersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avertissements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Haftungsausschluss")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dichiarazioni di non responsabilità")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отказ от ответственности")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargo de responsabilidad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("免责声明")
	if (locale === "ja") return /** @type {LocalizedString} */ ("免責事項")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अस्वीकरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avisos legais")
	return /** @type {LocalizedString} */ ("Disclaimers")
});